import React from 'react';
import Head from 'next/head'
import { APP_CONFIG } from '../../Config';

function groupByKey(array, key) {
    return array
        .reduce((sum, curr) => {
            if(curr[key] === undefined) return sum;

            if (curr.all_hours) {
                return Object
                    .assign(
                        sum,
                        { '00:00:00,23:59:59': [ ...(sum['00:00:00,23:59:59'] || []), curr ] }
                    )
            }

            if (curr.no_hours) {
                return sum
            }

            return Object
                .assign(
                    sum,
                    { [curr[key]]:( sum[curr[key]] || [] ).concat(curr) }
                )
        }, {})
}


const Schema = ({facility}) => {
    const days = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ]

    const hoursArr = Object.entries(facility.hours).map(e => {
        return {...e[1], hourRange: [e[1].open_time, e[1].close_time]}
    })

    const dayObj = Object
        .entries(groupByKey(hoursArr, 'hourRange'))
        .map(e => {
            return {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": e[1].map(i => days[i.day_of_week - 1]),
                "opens": e[0].split(',')[0],
                "closes": e[0].split(',')[1]
            }
        })

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "SelfStorage",
        "name": facility.facility_name,
        "image": facility.logo_file,
        "@id": facility.facility_id,
        "url": `${APP_CONFIG.APP_URL}/facilities/${facility.facility_id}`,
        "telephone": facility.phone,
        "address": {
            "@type": "PostalAddress",
            "streetAddress": facility.address,
            "addressLocality": facility.city,
            "addressRegion": facility.state,
            "postalCode": facility.zipcode,
            "addressCountry": facility.country
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": facility.marker.lat,
            "longitude": facility.marker.lng
        },
        "openingHoursSpecification": dayObj
    }

    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
            />
        </Head>
    );
};

export default Schema;
